import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CampaignStepType } from '../../../../business-entities/campaign-list-model';
import { CampaignTemplateModel } from '../../../../business-entities/campaign-template-model';
import { CampaignTemplateService } from '../../../../business-services/campaign-template.service';
import { TemplateBusinessService } from '../../../../business-services/template-service';
import Quill from 'quill';

@Component({
  selector: 'app-edit-campaign-template',
  templateUrl: './edit-campaign-template.component.html',
  styleUrls: ['./edit-campaign-template.component.css']
})
export class EditCampaignTemplateComponent implements OnInit {
  //#region variable intialize
  @Input() modelFlag: any;
  @Input() templateId: any;

  templateform: FormGroup;
  channel = CampaignStepType;
  template: CampaignTemplateModel;
  isValid = true;
  templateFieldList: any;
  channelTypeList = [
    { id: 1, campaignViaCode: 'lblEmail' },
    { id: 2, campaignViaCode: 'lblSms' },
  ];
  quill: Quill;
  options = {
    toolbar: {
      container: [
        [{'undo':'Undo'}, {'redo': 'Redo'}],
        [{'direction': 'rtl'}, 'blockquote'],
        [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }, { 'header': 4 }],
        ['bold', 'italic', 'strike'],
        [{'script': 'super'}, {'script': 'sub'}],
        ['link'],
        [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
        [{'list': 'ordered'}, {'list': 'bullet'}],
        ['clean']
      ],
      handlers: {
        redo() {
          this.quill.history.redo();
        },
        undo() {
          this.quill.history.undo();
        }
      }
    },
    history: {delay: 500, maxStack: 500, userOnly: true}
  };
  //#endregion

  //#region constructor and service intialize
  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private userService: UserDataService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService,
    private cd: ChangeDetectorRef,
    private templateService: TemplateBusinessService,
    private campaignTemplateService: CampaignTemplateService) {
  }
  //#endregion

  //#region ngOnInit and API Methods
  ngOnInit(): void {
    this.templateform = this.formBuilder.group({
      templateName: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      channel: [1, [Validators.required]],
      body: ['', [Validators.required]]
    });
    this.GetLists();
    if (this.modelFlag != 'add') {
      this.getTemplateById();
    }
    if (this.modelFlag == 'view') {
      this.templateform.controls['templateName'].disable();
      this.templateform.controls['subject'].disable();
      this.templateform.controls['channel'].disable();
    }
  }

  async GetLists() {
    this.spinner.show();
    await this.templateService.GetTemplate(0).then(res => {
      this.templateFieldList = res.responseObject.moduleList.find(x => x.name == 'Campaign')?.templateField.split(',');
      this.templateFieldList = this.templateFieldList?.sort((a, b) => {
        return (a < b ? -1 : 1) * (1);
      });
      this.spinner.hide();
    })
  }

  getTemplateById() {
    this.spinner.show();
    this.campaignTemplateService.getTemplateById(this.templateId).then((response: any) => {
      if (response) {
        this.template = response.data;
        this.templateform.patchValue({
          templateName: this.template.name,
          subject: this.template.subject,
          body: this.template.body,
          channel: this.template.channel
        })
        this.template.updatedBy = this.userService.currentUserValue.name;
      }
      this.spinner.hide();
    });
  }

  AddTemplate() {
    if (this.isValid) {
      this.spinner.show();
      let template = {
        id : this.template.id,
        name: this.templateform.controls['templateName'].value,
        subject: this.templateform.controls['subject'].value,
        body: this.templateform.controls['body'].value,
        channel: this.templateform.controls['channel'].value,
        updatedBy : this.template.updatedBy
      }
      this.campaignTemplateService.addUpdateTemplate(template).then(response => {
        if (response && response.statusCode == 201) {
          this.toastr.success(this.translate.instant("lblTemplateSavedSuccessfully"));
          this.activeModal.close({ success: true });
        }
        this.spinner.hide();
      })
    }
  }
  //#endregion

  //#region  Other methods
  get cf() {
    return this.templateform.controls;
  }

  OnClose() {
    this.activeModal.close()
  }
  //#endregion
}
